var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditProfilePic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#52509A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0674 12.2975C26.4166 11.6466 25.3613 11.6466 24.7104 12.2975L23.3413 13.6667L27 17.3254L28.3692 15.9563C29.02 15.3054 29.02 14.2501 28.3692 13.5993L27.0674 12.2975ZM29.1548 16.742C30.2396 15.6572 30.2396 13.8984 29.1548 12.8136L27.8531 11.5118C26.7683 10.427 25.0095 10.427 23.9247 11.5118L22.1632 13.2733C22.1631 13.2735 22.1629 13.2737 22.1627 13.2738C22.1626 13.274 22.1624 13.2741 22.1623 13.2743L11.0516 24.3849C10.9474 24.4891 10.8889 24.6304 10.8889 24.7778V29.2222C10.8889 29.529 11.1376 29.7778 11.4445 29.7778H15.8889C16.0363 29.7778 16.1776 29.7192 16.2818 29.615L29.1548 16.742ZM26.2144 18.1111L22.5556 14.4523L12 25.0079V28.6667H15.6588L26.2144 18.1111Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfilePic);
export default __webpack_public_path__ + "static/media/edit-profile-pic.e140501e4722827db0e12ba5863fb318.svg";
export { ForwardRef as ReactComponent };